import React from "react";
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import SectionEvent from "../../../components/sections/front/Events/SectionEvent";
import { useBanner } from "../../../providers/BannerProviders";

const EventList = () => {
  const { data } = useBanner();
  const blogsBanner = data?.data?.find(
    (item) => item?.bannerType === "updatesAndBlogs"
  );
  return (
    <>
      <PageBanner title={"Events"} image={blogsBanner?.image?.url} />
      <SectionEvent />
      <OurPartners />
    </>
  );
};

export default EventList;
